import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from '@mui/material'

const dialogPaperSx = {
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
}

const dialogTitleSx = {
  fontSize: '18px',
  fontWeight: 600,
  color: '#0C1229',
  padding: '20px 24px',
  borderBottom: '1px solid #f2f2f2',
}

const dialogContentSx = {
  padding: '20px 24px !important',
}

const helperTextSx = {
  fontSize: 13,
  color: '#475569',
  margin: 0,
  lineHeight: 1.5,
}

const dialogActionsSx = {
  padding: '16px 24px',
  borderTop: '1px solid #f2f2f2',
  gap: '8px',
}

const cancelButtonSx = {
  textTransform: 'none',
  fontWeight: 500,
  color: '#0C1229',
  borderColor: '#f2f2f2',
  borderRadius: '8px',
  padding: '8px 20px',
  '&:hover': {
    backgroundColor: '#f2f2f2',
    borderColor: '#0C1229',
  },
}

const confirmButtonSx = {
  textTransform: 'none',
  fontWeight: 600,
  backgroundColor: '#15803d',
  borderRadius: '8px',
  padding: '8px 24px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#166534',
  },
}

const CompleteActionDialog = ({ action, open, onClose, onConfirm, submitting, zIndex }) => {
  if (!action) return null

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: dialogPaperSx }}
      sx={zIndex ? { zIndex } : undefined}
    >
      <DialogTitle sx={dialogTitleSx}>Mark this remedial as complete?</DialogTitle>
      <DialogContent sx={dialogContentSx}>
        <p style={helperTextSx}>
          Marking &ldquo;<strong>{action.title}</strong>&rdquo; as complete will
          {' '}<strong>create a task and immediately mark it as done</strong>, so the completion
          is recorded in your task history, assigned to you and linked to this remedial.
          The remedial then shows as <strong>complete</strong>.
        </p>
      </DialogContent>
      <DialogActions sx={dialogActionsSx}>
        <Button onClick={onClose} variant="outlined" sx={cancelButtonSx} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={submitting}
          sx={confirmButtonSx}
        >
          {submitting ? 'Marking as complete…' : 'Mark as complete'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CompleteActionDialog
